// extracted by mini-css-extract-plugin
export default {"sidebarMenuItem":"app-portainer-components-sidebar-SidebarMenuItem-SidebarMenuItem-module__sidebar-menu-item"};